export default {
	//政治面貌
	political: ["中共党员", "中共预备党员", "共青团员", "民革党员", "民盟盟员", "民建会员", "民进会员", "农工党党员", "致公党党员", "九三学社社员", "台盟盟员",
		"无党派人士", "普通居民"
	],
}
